// @flow

import { i18n } from 'shared/utils';

export default () => [
  {
    label: i18n.t('Inventory # · Low to High'),
    value: { field: 'ITEM_NUMBER', direction: 'ASC' },
  },
  {
    label: i18n.t('Inventory # · High to Low'),
    value: { field: 'ITEM_NUMBER', direction: 'DESC' },
  },
  {
    label: i18n.t('Name · A to Z'),
    value: { field: 'NAME', direction: 'ASC' },
  },
  {
    label: i18n.t('Name · Z to A'),
    value: { field: 'NAME', direction: 'DESC' },
  },
  {
    label: i18n.t('Date Modified · Oldest'),
    value: { field: 'UPDATED_AT', direction: 'ASC' },
  },
  {
    label: i18n.t('Date Modified · Most Recent'),
    value: { field: 'UPDATED_AT', direction: 'DESC' },
  },
  {
    label: i18n.t('Date Created - Oldest'),
    value: { field: 'CREATED_AT', direction: 'ASC' },
  },
  {
    label: i18n.t('Date Created - Most Recent'),
    value: { field: 'CREATED_AT', direction: 'DESC' },
  },
];
